const getters = {
    permissionRouter:state=>state.permission.permissionRouter,
    cacheRouter:state=>state.menu.CacheView
}
export default getters